module.exports = __webpack_public_path__ + "assets/img/shredder_active.1b74bf6b.png";